import { useEffect, useState } from "react";
import { teamsApi } from "../api/endpoints";
import { ApiError } from "../api/client";
import type { Team } from "../api/types";

const SELECTED_KEY = "tt.selectedTeam";

export function getSelectedTeamId(): string | null {
  return localStorage.getItem(SELECTED_KEY);
}

export function setSelectedTeamId(id: string) {
  localStorage.setItem(SELECTED_KEY, id);
}

// Selection persists in localStorage so it is shared across Board/Epics/Ticket screens.
export function useTeams() {
  const [teams, setTeams] = useState<Team[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [selectedId, setSelected] = useState<string | null>(getSelectedTeamId());

  useEffect(() => {
    let active = true;
    teamsApi
      .list()
      .then((list) => {
        if (!active) return;
        setTeams(list);
        const stored = getSelectedTeamId();
        const valid = stored && list.some((t) => t.id === stored) ? stored : list[0]?.id ?? null;
        if (valid) {
          setSelectedTeamId(valid);
          setSelected(valid);
        }
      })
      .catch((err) => {
        if (active) setError(err instanceof ApiError ? err.message : "Failed to load teams.");
      });
    return () => {
      active = false;
    };
  }, []);

  const select = (id: string) => {
    setSelectedTeamId(id);
    setSelected(id);
  };

  return { teams, error, selectedId, select };
}
